export const PHONE_FORM_NAME = 'PHONE_VERIFICATION_PHONE';
export const TOKEN_FORM_NAME = 'PHONE_VERIFICATION_TOKEN';

export type Mode = 'newuser' | 'manual' | 'change' | 'forced' | 'strollers' | 'signup-no-user';
